// Copy and paste as Excel does it: rows of tab-separated cells. Excel quotes
// a cell that holds a tab, a line break or starts with a quote ("a""b"),
// and ends the text with a line break.

/** Cells of TSV text (rows of cells). */
export function parseTsv(text: string): string[][] {
  const rows: string[][] = []
  let row: string[] = []
  let cell = ''
  let i = 0
  const n = text.length
  let atStart = true
  while (i < n) {
    const ch = text[i]!
    if (atStart && ch === '"') {
      // quoted: up to the closing quote not followed by another
      let j = i + 1
      let v = ''
      let closed = false
      while (j < n) {
        const c = text[j]!
        if (c === '"') {
          if (text[j + 1] === '"') {
            v += '"'
            j += 2
            continue
          }
          closed = true
          j++
          break
        }
        v += c
        j++
      }
      // only a real quoted cell when the quote ends it
      if (closed && (j >= n || text[j] === '\t' || text[j] === '\n' || text[j] === '\r')) {
        cell = v
        i = j
        atStart = false
        continue
      }
    }
    atStart = false
    if (ch === '\t') {
      row.push(cell)
      cell = ''
      atStart = true
      i++
    } else if (ch === '\r' || ch === '\n') {
      row.push(cell)
      rows.push(row)
      row = []
      cell = ''
      atStart = true
      i += ch === '\r' && text[i + 1] === '\n' ? 2 : 1
    } else {
      cell += ch
      i++
    }
  }
  if (!atStart || cell !== '' || row.length > 0) {
    row.push(cell)
    rows.push(row)
  }
  return rows
}

function quote(s: string): string {
  return /[\t\r\n]/.test(s) || s.startsWith('"') ? `"${s.replace(/"/g, '""')}"` : s
}

/** TSV text of rows of cells (with the line break at the end, as Excel). */
export function toTsv(rows: string[][]): string {
  return rows.map((r) => r.map(quote).join('\t')).join('\r\n') + '\r\n'
}
